// extracted by css-extract-rspack-plugin
export default {"main":"main-fM2NXt","loader":"loader-azzJdB","header":"header-gzIFG0","headerActions":"headerActions-NjAidU","title":"title-pMA7JL"};